import { Tabs, TabList, Tab, TabPanels, TabPanel, Box, Tooltip, } from '@chakra-ui/react';
import React from 'react';
import SurveyFindingsWrapper from '../SurveyFindings/SurveyFindingsWrapper';
import { localise } from '../../../services/lang/lang';
import RemoteSubmissionsCard from '../RemoteSubmissions/RemoteSubmissionsCard';
import { useFeatureFlags } from '../../../context/FeatureFlagProvider';
import { RenderIf } from '../RenderIf/RenderIf';
import { useTokens } from '../../../context/TokenProvider';
const InspectionDetailTabs = ({ inspection }) => {
    const tokens = useTokens();
    const { useRemoteSubmissions } = useFeatureFlags();
    return (React.createElement(Tabs, { variant: "above-card", w: "100%" },
        React.createElement(TabList, null,
            React.createElement(Tab, { "data-testid": "inspection_detail_tabs__survey_findings_tab" }, localise('SURVEY_FINDINGS')),
            React.createElement(RenderIf, { condition: !!useRemoteSubmissions },
                React.createElement(Tab, { "data-testid": "inspection_detail_tabs__tenant_reports_tab", position: "relative" },
                    localise('TENANT_REPORTS'),
                    React.createElement(RenderIf, { condition: !!inspection.has_unread_remote_submissions },
                        React.createElement(Tooltip, { role: "tooltip", "data-testid": "conditional_tooltip", placement: "bottom", hasArrow: true, label: localise('UNREAD_TENANT_REPORTS') },
                            React.createElement(Box, { position: "absolute", top: "8px", "data-testid": "unread_tenant_reports_indicator", right: "8px", boxSize: "8px", bg: tokens.IconError, borderRadius: "full" })))))),
        React.createElement(TabPanels, null,
            React.createElement(TabPanel, null,
                React.createElement(SurveyFindingsWrapper, { inspection: inspection })),
            React.createElement(RenderIf, { condition: !!useRemoteSubmissions },
                React.createElement(TabPanel, null,
                    React.createElement(RemoteSubmissionsCard, { inspection: inspection }))))));
};
export default InspectionDetailTabs;
